import type { ReactNode } from 'react';

export const symbol_garden_cart: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M282.27-120Q248-120 224-144t-24-59v-381l-81-196H70q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-840 70-840h69q9.08 0 16.65 5.04 7.57 5.04 11.35 12.96l59.46 142H854q17.13 0 26.06 14.5Q889-651 881-636L756-390q51 6 85 43.97t34 89.56q0 56.47-39.07 95.97T740.91-121Q684-121 645-160.54q-39-39.53-39-95.46 0-20 5.5-39t16.5-35l-153-13-124 185q-11 17-29.49 27.5T282.27-120ZM686-384l120-236H250l62 148q11 26 32 42t50 19l292 27ZM283-181q2 0 18-10l106-158q-41-4-78.5-20T273-425l-13-28v251q0 9 7.5 15t15.5 6Zm456.65-4q32.35 0 53.85-21.77 21.5-21.78 21.5-52.88 0-32.35-21.25-53.85T740-335q-31.25 0-53.12 21.25Q665-292.5 665-260q0 31.25 21.77 53.12Q708.55-185 739.65-185ZM686-384l-292-27 292 27Z"
		/>
	</svg>
);
